import { PlanDetails } from './plan-details'

export default PlanDetails
